/**
 * Pre-compiled de messages for SplitButton
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { noActionsAvailable: `Keine Aktionen verfügbar` };
